<ul>
    <li>isOnHold: {{callInfo?.isOnHold}}</li>
    <li>isRecordingPaused: {{callInfo?.isRecordingPaused}}</li>
    <li>isMuted: {{callInfo?.isMuted}}</li>
    <li>initialCallId: {{callInfo?.initialCallId}}</li>
    <li>callStateTimestamp: {{callInfo?.callStateTimestamp}}</li>
    <li>queueName: {{callInfo?.queueName}}</li>
    <li>queueId: {{callInfo?.queueId}}</li>
    <li>queueTimestamp: {{callInfo?.queueTimestamp}}</li>
    <li>isSoftphoneCall: {{callInfo?.isSoftphoneCall}}</li>
    <li>acceptEnabled: {{callInfo?.acceptEnabled}}</li>
    <li>declineEnabled: {{callInfo?.declineEnabled}}</li>
    <li>muteEnabled: {{callInfo?.muteEnabled}}</li>
    <li>swapEnabled: {{callInfo?.swapEnabled}}</li>
    <li>conferenceEnabled: {{callInfo?.conferenceEnabled}}</li>
    <li>holdEnabled: {{callInfo?.holdEnabled}}</li>
    <li>recordEnabled: {{callInfo?.recordEnabled}}</li>
    <li>addCallerEnabled: {{callInfo?.addCallerEnabled}}</li>
    <li>extensionEnabled: {{callInfo?.extensionEnabled}}</li>
    <li>isReplayable: {{callInfo?.isReplayable}}</li>
    <li>isBargeable: {{callInfo?.isBargeable}}</li>
    <li>isExternalTransfer: {{callInfo?.isExternalTransfer}}</li>
    <li>showMuteButton: {{callInfo?.showMuteButton}}</li>
    <li>showRecordButton: {{callInfo?.showRecordButton}}</li>
    <li>showAddCallerButton: {{callInfo?.showAddCallerButton}}</li>
    <li>showAddBlindTransferButton: {{callInfo?.showAddBlindTransferButton}}</li>
    <li>showMergeButton: {{callInfo?.showMergeButton}}</li>
    <li>showSwapButton: {{callInfo?.showSwapButton}}</li>
    <li>removeParticipantVariant: {{callInfo?.removeParticipantVariant}}</li>
    <li>additonalFields: {{callInfo?.additionalFields ? stringifyAdditionalFields() : ''}}</li>
    <li>isMultiParty: {{callInfo?.isMultiParty}}</li>
</ul>